import { DEFAULT_CAUSE_ID } from "@playlive/fundraiser-data/config";
import {
  DEMO_CAMPAIGN_ID,
  DEMO_CAMPAIGN_SLUG,
  DEMO_USER_SLUG,
} from "@playlive/fundraiser-data/demo";

export const donors = [
  { name: "Donor 1", color: "red", id: "red1", amount: "100" },
  { name: "Donor 2", color: "red", id: "red2", amount: "200" },
  { name: "Donor 3", color: "red", id: "red3", amount: "200" },
  { name: "Donor 4", color: "red", id: "red4", amount: "300" },
  { name: "Donor 5", color: "red", id: "red5", amount: "4000" },
  { name: "Donor 6", color: "red", id: "red6", amount: "4500" },
  { name: "Donor 7", color: "red", id: "red7", amount: "4600" },
  { name: "Donor 8", color: "red", id: "red8", amount: "4700" },
  { name: "Donor 9", color: "red", id: "red9", amount: "4800" },
  { name: "Donor 10", color: "red", id: "red10", amount: "5000" },
];

export const previous = [
  {
    name: "Fundraising for the kids",
    year: "2024",
    color: "red",
    id: "red5",
    amount: "4000",
  },
  {
    name: "We're fundraising for St. Jude!",
    year: "2023",
    color: "red",
    id: "red4",
    amount: "3000",
  },
  {
    name: "2022 St. Jude Play Live fundraiser",
    year: "2022",
    color: "red",
    id: "red3",
    amount: "2000",
  },
  {
    name: "Let's raise money for the kids",
    year: "2021",
    color: "red",
    id: "red2",
    amount: "2000",
  },
  {
    name: "Our 2020 St. Jude Play Live fundraiser",
    year: "2020",
    color: "red",
    id: "red1",
    amount: "1000",
  },
];

export const rewards = [
  {
    name: "Reward 1",
    active: true,
    id: "1",
    quantity: 100,
    quantity_remaining: 2,
    highlighted: false,
    amount: {
      value: "100",
    },
  },
  {
    name: "Reward 2",
    active: true,
    id: "2",
    quantity: 100,
    quantity_remaining: 10,
    highlighted: true,
    amount: {
      value: "200",
    },
  },
  {
    name: "Reward 3",
    active: true,
    id: "3",
    quantity: 100,
    quantity_remaining: 9,
    highlighted: false,
    amount: {
      value: "300",
    },
  },
  {
    name: "Reward 4",
    active: true,
    id: "4",
    quantity: 100,
    quantity_remaining: 80,
    highlighted: true,
    amount: {
      value: "400",
    },
  },
  {
    name: "Reward 5",
    active: true,
    id: "5",
    quantity: 100,
    quantity_remaining: 20,
    highlighted: false,
    amount: {
      value: "500",
    },
  },
  {
    name: "Reward 6",
    active: false,
    id: "6",
    quantity: 100,
    quantity_remaining: 20,
    highlighted: false,
    amount: {
      value: "500",
    },
  },
];
export const targets = [
  { name: "Target 1", color: "red", id: "red1", amount: "100" },
  { name: "Target 2", color: "red", id: "red2", amount: "200" },
  { name: "Target 3", color: "red", id: "red3", amount: "200" },
  { name: "Target 4", color: "red", id: "red4", amount: "300" },
  { name: "Target 5", color: "red", id: "red5", amount: "400" },
];

export const fakeTiltifyUser = {
  description: "Test User's description",
  id: "test-user-id",
  legacy_id: 1,
  slug: DEMO_USER_SLUG,
  social: {
    discord: null,
    facebook: null,
    instagram: null,
    snapchat: null,
    tiktok: null,
    twitch: null,
    twitter: null,
    website: null,
    youtube: null,
  },
  total_amount_raised: {
    currency: "USD",
    value: "125.00",
  },
  url: `https://tiltify.com/@${DEMO_USER_SLUG}`,
  username: DEMO_USER_SLUG,
};

export const fakeTiltifyPoll = {
  active: true,
  amount_raised: {
    currency: "usd",
    value: "125.00",
  },
  id: "test-poll-id",
  inserted_at: "2024-10-18T21:44:28.314Z",
  legacy_id: 1,
  name: "Test Poll",
  options: [
    {
      amount_raised: {
        currency: "usd",
        value: "100.00",
      },
      id: "test-poll-option-id-one",
      inserted_at: "2024-10-18T21:44:28.314Z",
      legacy_id: 1,
      name: "Poll Option One",
      updated_at: "2024-10-18T21:44:28.314Z",
    },
    {
      amount_raised: {
        currency: "usd",
        value: "25.00",
      },
      id: "test-poll-option-id-two",
      inserted_at: "2024-10-18T21:44:28.314Z",
      legacy_id: 2,
      name: "Poll Option Two",
      updated_at: "2024-10-18T21:44:28.314Z",
    },
  ],
  updated_at: "2024-10-18T21:44:28.314Z",
};

export const fakeTiltifyCampaign = {
  amount_raised: {
    currency: "usd",
    value: "125.00",
  },
  avatar: null,
  cause_id: DEFAULT_CAUSE_ID,
  description: "Description for Test Campaign",
  donate_url: `https://donate.tiltify.com/${DEMO_CAMPAIGN_SLUG}`,
  fundraising_event_id: null,
  goal: {
    currency: "usd",
    value: "1000.00",
  },
  has_schedule: true,
  id: DEMO_CAMPAIGN_ID,
  inserted_at: "2024-10-17T21:05:44.503Z",
  legacy_id: 1,
  livestream: null,
  name: "Test Campaign",
  original_goal: {
    currency: "usd",
    value: "500.00",
  },
  published_at: "2024-10-17T21:05:44.503Z",
  retired_at: null,
  slug: DEMO_CAMPAIGN_SLUG,
  status: "published",
  supporting_type: "public",
  total_amount_raised: {
    currency: "usd",
    value: "125.00",
  },
  updated_at: "2024-10-17T21:05:44.503Z",
  url: `https://tiltify.com/@${DEMO_USER_SLUG}/${DEMO_CAMPAIGN_SLUG}`,
  user: fakeTiltifyUser,
  user_id: fakeTiltifyUser.id,
};

/**
 * Demo donor leaderboard, shaped like a `MonetaryLeaderboardEntry` row
 * from `GET /leaderboard-with-exclusions/{campaignID}`.
 *
 * QA runs with `isTestMode`, which seeds `tiltifyCampaignID` with
 * `DEMO_CAMPAIGN_ID` — a campaign Tiltify has never heard of. Every
 * leaderboard call for it 404s upstream, so the exclusion dashboard had
 * nothing to render. `useLeaderboardExclusions` serves these rows
 * instead of hitting the network whenever the selected campaign is a
 * demo campaign.
 *
 * Sorted descending by amount to match what the real endpoint returns
 * (Tiltify ranks server-side), so the dashboard's row order is
 * representative without any client-side sorting.
 */
export const fakeLeaderboardEntries = [
  { id: "demo-donor-1", name: "PixelPaladin", amount: 500 },
  { id: "demo-donor-2", name: "QuestForACure", amount: 425.5 },
  { id: "demo-donor-3", name: "HealerHannah", amount: 300 },
  { id: "demo-donor-4", name: "SpeedrunSam", amount: 250 },
  { id: "demo-donor-5", name: "CouchCoopCarl", amount: 175.25 },
  { id: "demo-donor-6", name: "RetroRhiannon", amount: 125 },
  { id: "demo-donor-7", name: "LootDropLeo", amount: 100 },
  { id: "demo-donor-8", name: "Anonymous", amount: 75 },
  { id: "demo-donor-9", name: "BossRushBecca", amount: 50 },
  { id: "demo-donor-10", name: "NoScopeNadia", amount: 25 },
];

/**
 * Donor names pre-hidden in the demo dashboard, so QA opens on a state
 * that already exercises the "ghost row" branch (excluded donors render
 * with `amount: 0, visible: false` so operators can un-hide them).
 */
export const fakeLeaderboardExclusions = ["TrollUser123"];
